
export default function ArrayUtilService() {
    this.swapItems = swapItems;
    this.toTop = toTop;
    this.toBottom = toBottom;
    this.remove = remove;
    this.removeItems = removeItems;
    this.findValueByProperty = findValueByProperty;

    function swapItems(arr, a, b) {
        if ((a >= 0 && a < arr.length) && (b >= 0 && b < arr.length)) {
            var temp = arr[b];
            arr[b] = arr[a];
            arr[a] = temp;
        }
    }

    function toTop(arr, index) {
        var item = arr[index];
        arr.splice(index, 1);
        arr.splice(0, 0, item);
    }

    function toBottom(arr, index) {
        var item = arr[index];
        arr.splice(index, 1);
        arr.splice(arr.length, 0, item);
    }

    function remove(arr, index) {
        if (index >= 0 && index < arr.length) {
            arr.splice(index, 1);

            return arr;
        }
    }

    function removeItems(arrA, items) {
        return _.filter(arrA, function (a_ele) {
            return !_.findWhere(items, a_ele);
        });
    }

    function findValueByProperty(arr, prop, value) {
        return _.some(arr, function (ele) {
            return ele[prop] === value;
        });
    }
}
